import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelCheckbox as _vModelCheckbox, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-869945d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cash-registers" }
const _hoisted_2 = { class: "flash-messages" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Kasser", -1))
const _hoisted_4 = { class: "registers" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("header", null, [
  /*#__PURE__*/_createElementVNode("h2", null, "Ny kasse")
], -1))
const _hoisted_6 = { class: "register-form" }
const _hoisted_7 = { class: "label name" }
const _hoisted_8 = { class: "field-error" }
const _hoisted_9 = { class: "label is-mobile-terminal" }
const _hoisted_10 = { class: "label receipt_printer" }
const _hoisted_11 = { class: "field-error" }
const _hoisted_12 = {
  key: 0,
  class: "label terminal"
}
const _hoisted_13 = { class: "field-error" }
const _hoisted_14 = { class: "send-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Messages = _resolveComponent("Messages")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Card = _resolveComponent("Card")!
  const _component_CollapseTransition = _resolveComponent("CollapseTransition")!
  const _component_RegisterEditBox = _resolveComponent("RegisterEditBox")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Messages)
    ]),
    _createElementVNode("header", null, [
      _hoisted_3,
      _createVNode(_component_Button, {
        onClick: _ctx.newRegister,
        color: "green"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Ny Kasse")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_CollapseTransition, null, {
        default: _withCtx(() => [
          (_ctx.showNewRegister)
            ? (_openBlock(), _createBlock(_component_Card, {
                key: 0,
                class: "register"
              }, {
                default: _withCtx(() => [
                  _hoisted_5,
                  _createElementVNode("form", _hoisted_6, [
                    _createElementVNode("label", _hoisted_7, [
                      _createTextVNode(" Navn på Kasse "),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.form.name]
                      ]),
                      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.form.errors.name), 1)
                    ]),
                    _createElementVNode("label", _hoisted_9, [
                      _withDirectives(_createElementVNode("input", {
                        type: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.terminal_is_mobile) = $event))
                      }, null, 512), [
                        [_vModelCheckbox, _ctx.form.terminal_is_mobile]
                      ]),
                      _createTextVNode(" Bruker mobil bankterminal ")
                    ]),
                    _createElementVNode("label", _hoisted_10, [
                      _createTextVNode(" Navn på kvitteringsskriver "),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.receipt_printer) = $event))
                      }, null, 512), [
                        [_vModelText, _ctx.form.receipt_printer]
                      ]),
                      _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.form.errors.receipt_printer), 1)
                    ]),
                    (!_ctx.form.terminal_is_mobile)
                      ? (_openBlock(), _createElementBlock("label", _hoisted_12, [
                          _createTextVNode(" Betalingsterminal ID "),
                          _withDirectives(_createElementVNode("input", {
                            type: "text",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.terminal_id) = $event))
                          }, null, 512), [
                            [_vModelText, _ctx.form.terminal_id]
                          ]),
                          _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.form.errors.terminal_id), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_Button, {
                        color: "green",
                        onClick: _ctx.sendForm
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Lagre")
                        ]),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_Button, {
                        color: "gray",
                        onClick: _ctx.abortNewRegister
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Avbryt")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cashRegisters, (register) => {
        return (_openBlock(), _createBlock(_component_Card, { class: "register" }, {
          default: _withCtx(() => [
            _createVNode(_component_RegisterEditBox, { register: register }, null, 8, ["register"])
          ]),
          _: 2
        }, 1024))
      }), 256))
    ])
  ]))
}